import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'
import { roundAmount } from 'src/utils/roundAmount'

type Props = Readonly<{
  marbleColor: string
  marbleUuid: string
  multipliers?: Record<string, number>
  boostPercentage?: number
}>

export function IrlAltOddsValue({ marbleColor, marbleUuid, multipliers, boostPercentage }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const translatedColor = getTranslatedMarbleColor(marbleColor, t)

  if (!multipliers || !multipliers[marbleUuid]) {
    return <span className="marble-odds-value">{translatedColor}</span>
  }

  const baseMultiplier = multipliers[marbleUuid]
  const boostedMultiplier = boostPercentage
    ? baseMultiplier * (1 + boostPercentage / 100)
    : baseMultiplier

  return (
    <span className="marble-odds-value">
      <span className="marble-odds-value-color">{translatedColor}</span>
      <span className="marble-odds-value-multiplier">{roundAmount(boostedMultiplier)}x</span>
    </span>
  )
}
